import React from 'react';
import { LoginLayout } from './LoginLayout';
import { ForgotPassword } from './forgot-password/ForgotPassword';

export const ForgotPasswordView = () => {
  return (
    <LoginLayout>
      <ForgotPassword />
    </LoginLayout>
  );
};
